import { render, staticRenderFns } from "./Appearance.vue?vue&type=template&id=3a2c6dbe&scoped=true"
var script = {}
import style0 from "./Appearance.vue?vue&type=style&index=0&id=3a2c6dbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2c6dbe",
  null
  
)

export default component.exports